/**
 * @file 选项详情
 */

import styled from 'styled-components'

import { RichTextRenderer } from 'packages/components/RichText'

/**
 * 选项详情
 *
 * @param param - 参数
 * @param param.title - 标题
 * @param param.content - 内容
 * @returns 组件
 */
export const OptionPreview: React.FC<{
  title: string
  content: string
}> = ({ title, content }) => {
  return (
    <Box>
      <Title>{title}</Title>
      <RichTextRenderer value={content} />
    </Box>
  )
}

const Box = styled.div`
  padding: 24px 32px 6px 32px;
`

const Title = styled.div`
  font-size: 24px;
  line-height: 32px;
  text-align: center;
  margin-bottom: 12px;
  color: ${(props) => props.theme.text._1};
`
